import React from "react";
import { HOW_IT_WORKS } from "../lib/constants";

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-16 sm:py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 sm:gap-16">
          {/* Sticky left rail */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">
                [ 02 — Workflow ]
              </div>
              <h2 className="font-display text-3xl sm:text-5xl font-semibold leading-[1] text-white">
                From sign-in to
                <br />
                <span className="brand-text-gradient">
                  service-center-ready
                </span>{" "}
                in four steps.
              </h2>
              <p className="text-zinc-400 mt-5 sm:mt-6 text-base lg:text-lg leading-relaxed max-w-md">
                We don&#39;t replace your manufacturer&#39;s app. We transform its
                authorized telemetry into predictive intelligence — warranty
                math, climate-aware forecasts, and personalized optimization.
              </p>
            </div>
          </div>

          {/* Steps */}
          <div className="lg:col-span-7 relative">
            <div
              className="absolute left-[27px] top-2 bottom-2 w-px"
              style={{
                background:
                  "linear-gradient(to bottom, #39FF14 0%, #00E5FF 50%, transparent 100%)",
                opacity: 0.35,
              }}
              aria-hidden="true"
            />
            <div className="space-y-10">
              {HOW_IT_WORKS.map((s, i) => (
                <div
                  key={s.step}
                  data-testid={`how-step-${i}`}
                  className="flex gap-7 group"
                >
                  <div className="relative shrink-0">
                    <div className="w-14 h-14 rounded-full bg-black border border-white/15 flex items-center justify-center font-mono text-sm text-white group-hover:border-[#39FF14]/50 transition-colors">
                      {s.step}
                    </div>
                  </div>
                  <div className="pt-2">
                    <h3 className="font-display text-2xl font-semibold text-white mb-2.5">
                      {s.title}
                    </h3>
                    <p className="text-zinc-400 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
